<template>
  <b-button
    v-if="$store.state.userProfile"
    name="like-button"
    variant="link"
    pill
    @click="onClick"
    :disabled="value === null"
    :class="[value ? '' : 'text-muted', 'mx-2 pt-1']"
  >
    <!-- Need to wrap in spans to make fontawesome work with reactivity -->
    <span v-show="value === true">
      <font-awesome-icon
        title="Click to unlike"
        :icon="['fas', 'thumbs-up']"
        size="lg"
      />
    </span>
    <span v-show="value === false">
      <font-awesome-icon
        title="Click to like"
        :icon="['fal', 'thumbs-up']"
        size="lg"
      />
    </span>
  </b-button>
  <span v-else>
    <span ref="loggedOut" class="d-inline-block" tabindex="0">
      <b-button
        variant="link"
        name="like-button"
        pill
        style="pointer-events: none"
        disabled
      >
        <font-awesome-icon
          title="Log in to like"
          :icon="['fal', 'thumbs-up']"
          size="lg"
        />
      </b-button>
    </span>
    <b-tooltip :target="() => $refs.loggedOut">Log in to like</b-tooltip>
  </span>
</template>

<script type="text/javascript">
import api from "@/api";

export default {
  name: "LikeButton",
  model: {
    prop: "value",
    event: "input",
  },
  data() {
    return {};
  },
  props: {
    value: Boolean,
    deckId: {
      type: String,
      required: true,
    },
  },
  methods: {
    async onClick() {
      const { liked } = await api.likeDeck(this.deckId, !this.value);
      this.$emit("input", liked);
    },
  },
};
</script>
